
function showSuccessModal() {
  document.getElementById("successModal").style.display = "block";
}

document.addEventListener("turbolinks:load", function() {
  var span = document.getElementsByClassName("close")[0];
  if (span === undefined) { return }
  span.onclick = function() {
    document.getElementById("successModal").style.display = "none";
  }

  window.onclick = function(event) {
    var modal = document.getElementById("successModal");
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
})
